import { cn } from "@/shared/lib/cn";

/**
 * Los "items" de It's The Best: los iconos 3D en el violeta de la marca
 * que Anahí entregó el 14-sep-2026 (`Items_It's the best/*.png`,
 * 1396×1404 con transparencia). Viven en `public/assets/items/*.webp`
 * a 320 px, que es más del doble de lo que se pintan: nítidos en
 * pantallas 2× sin cargar 1 MB por tarjeta.
 *
 * Cada llave es UN archivo, y el nombre es el de la carpeta original en
 * kebab-case, para que cuando llegue "Items v2" se sepa qué es qué.
 */
export const ITEM_ICONS = {
  box: "/assets/items/box.webp",
  copa: "/assets/items/copa.webp",
  "estado-membresia": "/assets/items/estado-membresia.webp",
  "fecha-recompra": "/assets/items/fecha-recompra.webp",
  "inicio-ciclo": "/assets/items/inicio-ciclo.webp",
  "mi-red": "/assets/items/mi-red.webp",
  "mis-pedidos": "/assets/items/mis-pedidos.webp",
  pagado: "/assets/items/pagado.webp",
  "por-liberar": "/assets/items/por-liberar.webp",
  puntos: "/assets/items/puntos.webp",
  reloj: "/assets/items/reloj.webp",
  tarjeta: "/assets/items/tarjeta.webp",
  tienda: "/assets/items/tienda.webp",
  wallet: "/assets/items/wallet.webp",
} as const;

export type ItemIconKey = keyof typeof ITEM_ICONS;

export interface ItemIconProps {
  item: ItemIconKey;
  /** Tamaño en píxeles CSS (cuadrado). Por omisión 44, el chip del KPI. */
  size?: number;
  className?: string;
}

/**
 * Un item, decorativo: va SIEMPRE junto a una etiqueta de texto que es
 * la que informa, así que `alt=""` y `aria-hidden` — un lector de
 * pantalla que lea "wallet, Comisiones disponibles" dice lo mismo dos
 * veces, y la segunda en inglés.
 *
 * `drop-shadow` en vez de sombra de caja: la sombra sigue la silueta del
 * objeto 3D, no el cuadrado transparente que lo contiene.
 */
export function ItemIcon({ item, size = 44, className }: ItemIconProps) {
  return (
    <img
      src={ITEM_ICONS[item]}
      alt=""
      aria-hidden="true"
      width={size}
      height={size}
      loading="lazy"
      decoding="async"
      draggable={false}
      className={cn("shrink-0 select-none object-contain drop-shadow-[0_6px_12px_rgba(92,79,214,0.28)]", className)}
      style={{ width: size, height: size }}
    />
  );
}
